<div class="login-container">
  <div class="login-container-box">
    <h4 class="playfair mb-2">Authentication</h4>
    <form [formGroup]="loginGroup">
      <div class="login-container-box-item">
        <label class="t-text-transform-uppercase">Username</label>
        <input
          id="login"
          type="text"
          inputmode="text"
          formControlName="username"
        />
      </div>
      <div class="login-container-box-item">
        <label class="t-text-transform-uppercase">Password</label>
        <input
          id="password"
          type="password"
          inputmode="text"
          formControlName="password"
        />
      </div>
      <div class="login-container-box-item">
        <div (click)="login()" class="login-container-box-item-button">
          <h6>login</h6>
          <app-icon style="margin-left: 0.4rem;" [icon]="Icons.arrowRight" [invert]="true"/>
        </div>
      </div>
      <div class="login-container-box-item login-container-box-item-error">
        {{ error }}
      </div>
    </form>
  </div>
</div>
